import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { LoaderService } from 'src/app/utils/loader.service';

interface DialogData {
  tnc:any[]
  data:any
}

@Component({
  selector: 'app-accept-purchase-orders',
  templateUrl: './accept-purchase-orders.component.html',
  styleUrls: ['./accept-purchase-orders.component.scss']
})
export class AcceptPurchaseOrdersComponent implements OnInit {
  poId;
  finalTnc:any[]=[]
  constructor(public dialogref: MatDialogRef<AcceptPurchaseOrdersComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private adminService: AdminService,
    private loaderService: LoaderService,
    private router: Router,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.poId = this.data["data"];  
    this.finalTnc = this.data.tnc  
  }

  close() {
    this.dialogref.close();
  }

  accept() {

    this.adminService.acceptPurchaseOrder(this.poId).subscribe(
      (res: any) => {
        this.loaderService.display(false)
        if (res.status == 200) {
          this.close();
        }
        this.toastr.success('Your PO is accepted', 'Success');
        this.router.navigate(['/admin/purchase-orders/active-po/', this.poId]);

      },
      err => {
        this.toastr.error('Sorry we cannot accept this order', 'Error');
        this.close();
        this.loaderService.display(false);
      }
    )

  }

}
